export default function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/utils/abs-floor.js